import invariant from 'tiny-invariant';
import { createContext, useContextSelector } from 'use-context-selector';
const ListContext = createContext(null);
export const ListProvider = ListContext.Provider;
export const useListContext = selector => useContextSelector(ListContext, ctx => {
  invariant(ctx !== null, "Component can't be used outside of <List /> component");
  return selector(ctx);
});